import {
  Directive,
  EmbeddedViewRef,
  Input,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';

import { LoginSessionFacadeService } from '@digital-platform/users/services';

@Directive({
  selector: '[digitalPlatformPermission]'
})
export class PermissionDirective<T = unknown> {
  private hasPermission: boolean;
  private _templateRef: TemplateRef<T> = null;
  private _viewRef: EmbeddedViewRef<T> = null;

  constructor(
    private templateRef: TemplateRef<T>,
    private _viewContainer: ViewContainerRef,
    private readonly facade: LoginSessionFacadeService
  ) {
    this._templateRef = templateRef;
  }

  @Input() set digitalPlatformPermission(permission: string | string[]) {
    let permissions: string[];

    if (Array.isArray(permission)) {
      permissions = [...permission];
    } else {
      permissions = [permission];
    }

    this._checkPermissions(permissions);
  }

  private async _checkPermissions(permissions: string[]) {
    this.hasPermission = false;

    await Promise.all(
      permissions.map(async permission => {
        const hasPermission = await this.facade.hasPermission(permission);
        this.hasPermission = this.hasPermission || hasPermission;
      })
    );

    this._updateView();
  }

  private _updateView() {
    if (this.hasPermission && !this._viewRef) {
      this._viewRef = this._viewContainer.createEmbeddedView(this._templateRef);
    } else if (!this.hasPermission && this._viewRef) {
      this._viewContainer.clear();
      this._viewRef = undefined;
    }
  }
}
